import moment from 'moment';


/**
 * 선택한 영상의 정보를 보고 재생하려는 영상이 LIVE인지 VOD인지 판별
 * 
 * @param {object} videoItem 
 * @return {string} 'live'/'vod'
 */
export function getStreamingType (videoItem) {
  const { start, stop, live } = videoItem;

  if(live){ 
    // NOTE: live 플래그가 있으면 그 플래그로 처리 ==> 채널 이름 클릭시 사용.
    return 'live';
  } else {
    const now = moment();
    const startTime = moment(start, 'YYYY-MM-DD HH:mm:ss');
    const stopTime = moment(stop, 'YYYY-MM-DD HH:mm:ss');
    if(startTime.isBefore(now)){  // VOD 영상
      if(stopTime.isBefore(now)){  // LIVE 영상
        return 'vod';
      } else {
        return 'live';
      }
    } else {
      // 방영전
    }
  }
};

/**
 * 녹화된 영상의 시작 시간과 스케쥴상의 시작시간이 반드시 일치하지 않기 때문에
 * 이 함수로 파일의 시작 시간과 웹서비스에서 온 시작 시간을 비교하여
 * 영상의 시작점을 웹서비스에서 온 시간으로 이동한다.
 * 
 * seek api를 이용하기 위해 초 단위로 결과값을 리턴한다.
 * 
 * @param {object} videoItem 
 * @return {number} seconds 
 */
export function setStartFrom (videoItem) {
  const {
    url,    // 실제 영상의 url
    start  // 스케쥴 상 시작시간
  } = videoItem;
  
  let startFrom = 0;

  if(Object.keys(videoItem).length > 0){
    const urlArray = url.split('/');
    const dateIndex = urlArray.length - 2;
    const timeIndex = urlArray.length - 1;
    const fileStartTime = moment(urlArray[dateIndex] + urlArray[timeIndex], 'YYYY-MM-DDHHmm00');  // file 녹화 초단위는 언제나 00초
    const scheduleStartTime = moment(start, 'YYYYMMDDHHmmss');
  
    startFrom = moment.duration(scheduleStartTime.diff(fileStartTime)).asSeconds();
  }

  return startFrom;
}


export function checkPlayContinously(currTime, videoItem) {
  const {stop, airDate} = videoItem;

   // 재생하는 날짜와 스케쥴 상의 날짜는 같은 날인 것으로 가정.
  const currentEnd = moment(airDate + currTime, 'YYYY-MM-DDHH:mm:ss');
  
  const scheduleEnd = moment(stop, 'YYYYMMDDHHmmss');
  return scheduleEnd.isAfter(currentEnd);
}


// WEBPACK FOOTER //
// ./src/components/video/util.js